export const config = {
  warranty: {
    baseUrl: import.meta.env.VITE_WARRANTY_API_BASE_URL
  },

  environment: import.meta.env.VITE_ENVIRONMENT,

  debug: {
    showHiddenInputDegubText:
      import.meta.env.VITE_SHOW_HIDDEN_INPUT_DEBUG_TEXT?.toLowerCase() === 'true'
  }
}
